module.exports = __webpack_public_path__ + "img/83400.a527b549.jpg";